import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery, handleSessionExpiredError } from '../../utils/auth';

export const contractApi = createApi({
  reducerPath: 'contractApi',
  baseQuery: getBaseQuery('/mantainer-portal/contract'),
  endpoints: (builder) => ({
    generateExcel: builder.mutation<any, number[]>({
      query: (postulationsIds) => {
        let url = '';
        for (let i = 0; i < postulationsIds.length; i++) {
          if (i === 0) {
            url += `?postulationIds=${postulationsIds[i]}`;
          } else {
            url += `&postulationIds=${postulationsIds[i]}`;
          }
        }
        return {
          url,
          // El responseHandler corre también sobre las respuestas de error. Si
          // se convierte todo a blob, el motivo que manda el servidor llega
          // como una URL `blob:` y se pierde; en el camino de error hay que
          // leer el JSON.
          responseHandler: async (response: Response) =>
            response.ok
              ? URL.createObjectURL(await response.blob())
              : response.json(),
        };
      },
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

export const { useGenerateExcelMutation } = contractApi;
